import { h, render } from "../_snowpack/pkg/preact.js";
import App from "./App.js";
const root = document.getElementById("root");

if (root) {
  render(h(App, null), root);
}